import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function trackReducer(state = initialState.trackState, action) {
    switch(action.type) {
        case types.GET_FEATURED_TRACKS:
            return {
                ...state,
                featuredTracks: action.tracks
            }
        case types.GET_TRACK:
            return {
                ...state,
                selectedTrack: action.track
            }
        case types.GET_MUSIC_CHARTS:
            return {
                ...state,
                charts: action.charts,
                chartsLastLoaded: new Date()
            }
        case types.GET_MUSIC_CHARTS_STATUS:
            return {
                ...state,
                chartLoadingStatus: action.loadingStatus
            }    
        case types.TRACK_CHANGED:
            return {
                ...state,
                nowPlaying: action.track
            }
        case types.PLAY_TRACK:
            return {
                ...state,
                nowPlaying: action.track,
                trackPlayed: true
            }
        case types.SET_TRACK_STATUS:
            return {
                ...state,
                trackPlaying: action.status.playing,
                trackPaused: action.status.paused
            }    
        case types.UPDATE_TRACK_RATING:
        {
            const trackID = action.trackRating.id;
            const rating = action.trackRating.rating; 
            return {
                ...state,
                featuredTracks: state.featuredTracks.map(track => {
                    if(track.ID == trackID){
                      return { ...track, Rating: rating };
                    }
                    return track;
                  }),
                charts: state.charts.map(track => {
                    if(track.ID === trackID){
                      return { ...track, Rating: rating };
                    }
                    return track;
                  }),
                nowPlaying: state.nowPlaying && state.nowPlaying.ID == trackID ? { ...state.nowPlaying, Rating: rating } : state.nowPlaying,
                selectedTrack: state.selectedTrack && state.selectedTrack.Track ? 
                    { 
                        ...state.selectedTrack, 
                        Track: { ...state.selectedTrack.Track, Rating: rating }, 
                        OtherTracks: state.selectedTrack.OtherTracks.map(track => {
                            if(track.ID === trackID){
                                return { ...track, Rating: rating };
                              }
                              return track;
                        })
                    } 
                    : state.selectedTrack 
            };
        }        
        default:
            return state;
    }
}